<template>
	<label v-if="label" class="mb-2 small text-dark" :for="label">{{
		label
	}}</label>
	<input
		v-bind="$attrs"
		:id="id"
		:value="modelValue"
		:placeholder="label"
		@change="$emit('update:modelValue', $event.target.files)"
		class="form-control form-control-lg"
		multiple="multiple"
		accept=".jpg,.jpeg,.png"
	/>
</template>
<script>
	export default {
		name: "BaseFileInput",
		props: {
			id: {
				type: [String, Number],
				default: null,
			},
			label: {
				type: String,
				default: null,
			},
			modelValue: {
				type: [String, Number, Array],
				default: null,
			},
			name: {
				type: String,
			},
		},
	};
</script>
